import i18n from 'i18next';
import { useMemo } from 'react';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentSortingFields } from '../../hooks';

export const ShipmentSortingSelect = ({
  placeholder = i18n.t('translation:default.fields.sortBy.select'),
  label = i18n.t('translation:default.fields.sortBy.label'),
  rules = [],
  name,
  editMode,
}) => {
  const { data = [], isLoading } = useGetShipmentSortingFields();

  const options = useMemo(
    () =>
      data.map((row) => ({
        label: row.columnName,
        value: row.columnValue,
      })),
    [data],
  );

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin="mb-0"
      rules={rules}
      name={name}
      editMode={editMode}
    />
  );
};
